export enum BackendTypeName {
    Handyman,
    Smartday,
    MyFleet,
    GuardSystems,
    Paikannin,
    Lommy
  }
  
  export interface BackendData {
    name: string,
    backendName: BackendTypeName,
    tenantId: string | null
  }

export function parseBackendData(backendDataString: string): BackendData {
    const backendStringArray: string[] = backendDataString.split(';');

    const typedBackendTypeString = backendStringArray[1] as keyof typeof BackendTypeName;

    const backendData: BackendData = {
      name: backendStringArray[0],
      backendName: BackendTypeName[typedBackendTypeString],
      tenantId: backendStringArray.length > 2 ? backendStringArray[2] : null
    };

    return backendData;
}

export function isValidBackend(backendData: BackendData) : boolean {
    return backendData.backendName === BackendTypeName.Handyman 
        || backendData.backendName === BackendTypeName.Smartday;
}